export const TELA_DE_CONTROLE = () => `/tela-de-controle`;
